import {getEnv} from '../../common/env/env';
import {ServerEnv} from '../../common/env/ServerEnv.enum';
import {TextViewerDataVo} from '../../common/shared/api/gateway/viewer/TextViewerDataVo.interface';
import {TextViewerData, ViewerDataType} from '../generated/types';
import {createTextViewerContentData} from './TextViewerContentData';

export function createTextViewerData({
  ats_server_url,
  meta_secure_url,
  contents_list,
}: TextViewerDataVo): TextViewerData {
  const env = getEnv().envName;
  const atsServerUrl =
    env === ServerEnv.Real || env === ServerEnv.Beta
      ? ats_server_url?.replace('http://', 'https://')
      : `https://${env}-dn-page.kakao.com/sdownload/resource?kid=`;

  return {
    type: ViewerDataType.TextViewerData,
    atsServerUrl,
    metaSecureUrl: meta_secure_url,
    contentsList: contents_list.map(content =>
      createTextViewerContentData(content)
    ),
  };
}
